import { ProjectComplianceTab as ProjectComplianceTabContent } from '../CatalogTabs';

export const ProjectComplianceTab = () => {
  return <ProjectComplianceTabContent />;
};
